import { GET_STUDENT_LIST, GET_STUDENT_LIST_SUCCESS, GET_TEACHER_ID, GET_TEACHER_ID_ERROR, GET_TEACHER_ID_SUCCESS, SELECT_STUDENT, SELECT_STUDENT_SUCCESS, SYNC_DATA, SYNC_DATA_SUCCESS } from "../action/studentSelectAction"


let initialState = {
    loading:false,
    error: "",
    teacherID: "",
    listStudent:[],
    selectedStudent:{},
    synced: false,
    syncronizing:false
}


export default function studentSelectReducer(state = initialState,action){
    switch(action.type){
        case GET_TEACHER_ID:
            return {...state, loading: true}
        case GET_TEACHER_ID_ERROR:
            return {...state, loading: false, error: action.payload}
        case GET_TEACHER_ID_SUCCESS:
            return {...state, loading: false, teacherID: action.payload}
        case GET_STUDENT_LIST:
            return {...state, loading:true}
        case GET_STUDENT_LIST_SUCCESS:
            return {...state, loading:false, listStudent: action.payload}
        case SELECT_STUDENT:
            return {...state, loading:true}
        case SELECT_STUDENT_SUCCESS: 
            return {...state, loading:false, selectedStudent:action.payload}
        case SYNC_DATA:
            return {...state, synced:false, syncronizing:true}
        case SYNC_DATA_SUCCESS:
            return {...state,synced:true, syncronizing:false}
        default:
            return state;
    }
}